import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'order',
        align:"center",
        width: 70
      },
    {
        title:Util.L('PackageNo'),
        key:'packageNo',
        width: 150
    },
    {
        title:Util.L('RefType'),
        align:"center",
        key:'refTypeName',
        width: 120
    },
    {
        title:Util.L('RefCode'),
        key:'refCode',
        width: 150
    },
    {
        title:Util.L('ExternalCode'),
        key:'externalCode',
        width: 150
    },
    {
        title:Util.L('CustomerName'),
        key:'customerName',
        width: 150
    },
    {
        title:Util.L('OrderPackage'),
        key:'orderPackage',
        align:"right",
        width: 150
    }
]